export default __webpack_public_path__ + "static/Cover-ff92917d2101e77d7efda77a441d4489.jpeg";